<template>
  <v-row>
    <v-col>
      <v-card>
        <v-container fluid>
          <v-row dense>
            <v-col class="font-weight-bold text-body-2" cols="auto">
              {{
                $moment(surgery.createdAt, "YYYY-MM-DD HH:mm:ss ZZ")
                  | moment("DD/MM/YYYY HH:mm")
              }}
            </v-col>
          </v-row>

          <v-divider />

          <v-row dense>
            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Cirurgia </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ surgeryIndication.surgeryType.name }}
                </v-col>
              </v-row>
            </v-col>

            <v-col v-if="surgeryIndication.surgeryTypeTechnique">
              <v-row dense>
                <v-col class="font-weight-bold"> Técnica </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ surgeryIndication.surgeryTypeTechnique.name }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Local </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ surgeryIndication.site }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Anestesia </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ surgeryIndication.anesthesia }}
                </v-col>
              </v-row>
            </v-col>

            <v-col>
              <v-row dense>
                <v-col class="font-weight-bold"> Materiais </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ materials }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="4">
              <v-row dense>
                <v-col class="font-weight-bold"> Observação </v-col>
              </v-row>

              <v-row dense>
                <v-col>
                  {{ surgeryIndication.observation }}
                </v-col>
              </v-row>
            </v-col>

            <v-col cols="auto">
              <authorization
                permissionKey="attendance_surgery"
                can="save"
                v-slot:default="{ authorization }"
              >
                <v-btn
                  small
                  icon
                  v-if="authorization"
                  :to="`cirurgia/${surgery.id}`"
                >
                  <v-icon>eva-external-link-outline</v-icon>
                </v-btn>
              </authorization>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "SurgeryListItem",
  props: {
    surgery: Object,
  },
  computed: {
    surgeryIndication() {
      return this.surgery.surgeryIndication;
    },
    materials() {
      return this.lodash.join(
        this.surgeryIndication.materials.map((e) => e.name),
        ", "
      );
    },
  },
};
</script>

<style lang="scss" scoped></style>
